export const enum NotificationLevel {
    SUCCESS,
    INFO,
    WARN,
    ERROR
}

export interface INotification {
    message: string;
    timeStamp: string;
    notificationLevel: NotificationLevel;
}

export interface INotificationContainerState {
    notifications: INotification[];
}
